@if (isSwitching$ | async) {
<atx-loader-overlay
  i18n-loaderText="@@SwitchingBasket"
  loaderText="Switching your basket..."
  data-e2e="cbasket-switching-overlay"
></atx-loader-overlay>
}

<atx-input-with-icon
  data-e2e="basket-input-container"
  class="mx-2 mb-2 sticky"
  [icon]="['fas', 'magnifying-glass']"
  (valueChange)="searchBasket($event)"
  initialValue=""
  placeholderText="Search for basket"
  i18n-placeholderText="
    basketSearch|Search basket input placeholder@@searchBasketInput"
></atx-input-with-icon>

@if (isGroupedView$ | async) {
<epc-grouped-baskets
  [activeBasketId]="activeBasketId$ | async"
  [loading]="loading$ | async"
  [allLoaded]="allLoaded$ | async"
  [searchTerm]="searchTerm"
>
</epc-grouped-baskets>
} @else {
<epc-baskets-list
  [activeBasketId]="activeBasketId$ | async"
  [loading]="loading$ | async"
  [allLoaded]="allLoaded$ | async"
  [searchTerm]="searchTerm"
>
</epc-baskets-list>
} @if (loading$ | async) {
<fa-icon
  [icon]="['fas', 'spinner']"
  [spin]="true"
  [pulse]="true"
  class="align-self-center"
></fa-icon>
}
